import { FC, SVGAttributes } from 'react'

type Props = SVGAttributes<SVGElement>

const IconArrow: FC<Props> = ({ ...rest }) => {
  return (
    <svg
      width='6'
      height='12'
      viewBox='0 0 6 12'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path d='M3.75 9.0075L3.75 -9.83506e-08L2.25 -1.63918e-07L2.25 9.0075L-3.9373e-07 9.0075L3 12L6 9.0075L3.75 9.0075Z' />
    </svg>
  )
}

export default IconArrow
